import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../../lib/server_helper';
import { fetch_one, fetch_all_with_count } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';
import HelpersPractice from '../../../../actions/helpers/practice';

import AttachmentIcon from '@mui/icons-material/Attachment';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TextsmsIcon from '@mui/icons-material/Textsms';
import Visibility from '@mui/icons-material/Visibility';

import {
  Box,
  Button as Btn,
  DialogActions,
  Grid,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGrid,
  Dt,
  Fab,
  IconButton,
  Typography
} from '../../../../components/v2/styled';
import { AiCoachAdviceReport } from '../../../../components/v2/dialogs/AiCoachAdviceReport';
import { Base } from '../../../../components/v2/dialogs/Base';
import { CoachEditAdvice } from '../../../../components/v2/dialogs/CoachEditAdvice';
import { SnackDestroyed } from '../../../../components/v2/snacks/Destroyed';
import { SnackSaved } from '../../../../components/v2/snacks/Saved';

import { Advice } from '../../../../models/Advice';
import { User } from '../../../../models/User';
import { CoachUserIntakeAdvicesNew } from './AdvicesNew';
import { useLocation, useNavigate } from 'react-router-dom';

const { DateTime } = require("luxon");
var he = require('he');

type Props = {
  user: User;
}

export const CoachUserIntakeAdvices: FunctionComponent<Props> = ({user}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const queryClient = useQueryClient();
  const { state } = useLocation();

  let count = 0;
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("advice_date DESC, episode DESC, idx DESC, id DESC");

  const [newAdvice, setNewAdvice] = useState<Advice>({attachments: []});
  const [clonedAdvice, setClonedAdvice] = useState<Advice>({attachments: []});
  const [editOpen, setEditOpen] = useState<boolean>(false);
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [destroyedOpen, setDestroyedOpen] = useState<boolean>(false);
  const [activeAdvice, setActiveAdvice] = useState<Advice>();
  const [aiReportOpen, setAiReportOpen] = useState<boolean>(false);
  const [showContent, setShowContent] = useState<string>();
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [anch, setAnch] = useState<null | HTMLElement>(null);
  const [menuAdvice, setMenuAdvice] = useState<Advice>();

  {/* 12 - demo */}
  {/* 21 - devoedingsbrug */}
  {/* 24 - act2nourish */}
  {/* 24 - inneverbist */}
  {/* 290 - dietistekristina */}
  {/* 291 - gezondmettanya */}
  {/* 324 - dietistelisatavernier */}
  {/* 368 - elkedams */}
  // const canTest = (
  //   login?.practice_id === 4 || 
  //   login?.practice_id === 12 || 
  //   login?.practice_id === 13 || 
  //   login?.practice_id === 21 || 
  //   login?.practice_id === 24 || 
  //   login?.practice_id === 33 || 
  //   login?.practice_id === 290 || 
  //   login?.practice_id === 291 || 
  //   login?.practice_id === 324 || 
  //   login?.practice_id === 368
  // );
  const canTest = HelpersPractice.practice_modules_v3({practice: currentPractice, check: 'ai_report'});


  const {
    data: objects,
    isLoading: objectsLoading,
    isError: objectsError,
    isSuccess: objectsSuccess,
    refetch: objectsRefetch,
  } = useQuery({
    queryKey: ["coach", "advices", (login?.practice_id || currentPractice?.id), {page: page, order: order}],
    queryFn: () =>
      fetch_all_with_count<Advice>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'advice',
          fields: [
            'id', 'advice_date', 'weight', 'advice_uploads|count', 'feedback_goals', 'feedback_education', 'feedback_deals', 'created_at',
            'updated_at', 'creator|id/full_name', 'editor|id/full_name', 'comment', 'deals', 'goals', 'education', 'weight', 'waist', 'attachments',
            'user_id', 'identification', 'idx', 'weight_diff_with_previous', 'weight_diff_with_episode', 'waist_diff_with_previous', 'waist_diff_with_episode',
            'next_time', 'internal_comment', 'anamnese', 'episode', 'idx', 'epi', 'chippa_status', 'chippa_report'
          ],
          sub_fields: {
            // 'anamnese': ['id', 'breakfast']
          },
          per_page: !!login?.settings?.nutri_advice?.use_advanced_index ? 1000 : 20,
          page: !!login?.settings?.nutri_advice?.use_advanced_index ? 0 : page,
          order: order,
          filter: {
            search: '',
            advanced: {
              user_id: user?.id,
              practice_id: currentPractice?.id
            }
          }
        },
        login
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    enabled: !!(login?.practice_id || currentPractice?.id) && !!user?.id,
  });





  useEffect(() => {
    if (!!state?.open && !!objects && !editOpen) {
      let ob = objects.filter(fff => fff.id === state.open)[0];
      if (!!ob) {
        setNewAdvice({
          ...ob,
          advice_date: DateTime.fromFormat(ob.advice_date, "y-LL-dd").toFormat("dd/LL/y")
        });
        setEditOpen(true);
      }
    }
  }, [objects, state]);




  const mutationDestroy = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<Advice>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/remove`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      objectsRefetch();
      setDestroyedOpen(true);
    },
  });
  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean;
    }) => {
      return fetch_one<Advice>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      // setIsEditPasswordError(false);
      // setEditPasswordSuccess(false);
      // setEditPasswordError(undefined);
      // setEditPasswordLoading(true);
      return true;
    },
    onError: (data, variables, context) => {
      // setIsEditPasswordError(true);
      // setEditPasswordError(data as any);
      // setEditPasswordLoading(false);
      return true;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["coach", "advices", user?.id, (login?.practice_id || currentPractice?.id), {page: page, order: order}] })
      navigate('.', {
        replace: true
      })
      objectsRefetch();
      console.log(variables);
      if (!variables.keepOpen) setEditOpen(false);
      if (!!variables.keepOpen) {console.log('set id'); setNewAdvice({...newAdvice, id: data.id});}
      setSavedOpen(true);
    },
  });






  const celleke = (id: any, content: any, left?: boolean, right?: boolean, bottom?: boolean) => {
    return rawCelleke(id, <>
      <Typography html sx={{
        // textOverflow: "ellipsis",
        height: 96,
        maxHeight: 96,
        overflow: 'hidden',
        "& p": {
          marginTop: 0,
          marginBottom: 0
        }
      }}>{content}</Typography>
      {((content || '').length > 75 || ((content || '').match(/<br/g) || [[]]).length > 3 || ((content || '').match(/<\/p>/g) || [[]]).length > 3) && <IconButton sx={{
        position: 'absolute',
        bottom: 4,
        right: 4,
        color: theme.palette.primary.main,
        backgroundColor: 'white !important'
      }} onClick={() => {
        setShowContent(content);
      }}><Visibility /></IconButton>}
    </>, left, right, bottom, false, {
      overflow: 'hidden',
      position: 'relative'
    });
  }
  const rawCelleke = (id: any, content: any, left?: boolean, right?: boolean, bottom?: boolean, noPadding?: boolean, extra?: any) => {
    return <Grid xs={2} sx={{
      // borderTop: '2px solid transparent',
      ...(!!left ? {borderLeft: '1px solid transparent'} : {}),
      ...(!!right ? {borderRight: '1px solid transparent'} : {}),
      ...(!!bottom ? {borderBottom: '1px solid transparent'} : {}),
      borderColor: theme.palette.primary.main,
      padding: !!noPadding ? 0 : 1,
      maxHeight: 112,
      height: 112,
      ...extra
    }}>
      {content}
    </Grid>;
  }




  


  const columns: GridColDef[] = [
    // { field: 'id', headerName: 'ID', width: 80 },
    { field: 'advice_date', headerName: t("coach.models.advices.advice_date", "Datum"), width: 240, renderCell: params => <>
      <Dt d={params.row.advice_date} f="cccc DDD" />
    </> },
    { field: 'weight', headerName: t("coach.models.advices.weight", "Gewicht"), width: 120 },
    { field: 'advice_uploads_count', headerName: t("coach.models.advices.uploads", "Uploads"), sortable: false, width: 120, renderCell: params => <>
      {params.row.advice_uploads_count > 0 && <Typography sx={{lineHeight: '52px'}}><AttachmentIcon sx={{marginBottom: -0.5, marginRight: 0.5}} /> {params.row.advice_uploads_count}</Typography>}
    </> },
    { field: 'feedback_count', headerName: t("coach.models.advices.feedback", "Feedback"), sortable: false, width: 120, renderCell: params => <>
      {((!!params.row.feedback_goals ? 1 : 0) + (!!params.row.feedback_education ? 1 : 0) + (!!params.row.feedback_deals ? 1 : 0)) > 0 && <Typography sx={{lineHeight: '52px'}}><TextsmsIcon sx={{marginBottom: -1, marginRight: 0.5}} /> {((!!params.row.feedback_goals ? 1 : 0) + (!!params.row.feedback_education ? 1 : 0) + (!!params.row.feedback_deals ? 1 : 0))}</Typography>}
    </> },
  ];
  
  return <>
    {!!login?.settings?.nutri_advice?.use_advanced_index && <>
      <CoachUserIntakeAdvicesNew user={user} />
    </>}
    {!login?.settings?.nutri_advice?.use_advanced_index && <>
      <DataGrid
        action_count={canTest ? 3 : 2}
        hideCount
        actions={(params) => {
          return (<>
            <IconButton title="Edit" color="default" onClick={() => {
              setNewAdvice({
                ...params.row,
                advice_date: DateTime.fromFormat(params.row.advice_date, "y-LL-dd").toFormat("dd/LL/y")
              });
              setEditOpen(true);
            }}>
              <EditIcon />
            </IconButton>
            {canTest && <IconButton title="Report (experimental)" color="warning" onClick={() => {
              setActiveAdvice(params.row);
              setAiReportOpen(true);
            }}>
              <AutoAwesomeIcon />
            </IconButton>}
            <IconButton title="Remove" destroyBtn color="default" onClick={() => {
              mutationDestroy.mutate({
                formData: {
                  object: 'advice',
                  id: params.row.id,
                  ob: {
                    id: params.row.id,
                  }
                }
              });
            }}>
              <DeleteIcon />
            </IconButton>
          </>);
        }}
        objectCount={count}
        getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
        objects={(objects || []).map(u => ({
          ...u,
          // name: [u.last_name, u.first_name].join(", "),
          // enabled: !!u.enabled && !!u.consent_status?.enabled
        }))}
        columns={columns}
        loader={objectsLoading}
        onSortModelChange={(a, b) => {
          let a_0_field:string = a[0].field;
          if (a_0_field === 'name') a_0_field = `last_name ${a[0].sort}, first_name`;
          setOrder([a_0_field, a[0].sort].join(' '));
        }}
        page={page}
        setPage={(p) => {setPage(p);}}
      />
    </>}

    <Fab
      onClick={() => {
        setClonedAdvice({
          ...((objects || [])[0] || {}),
          attachments: [],
          advice_date: DateTime.now().toFormat("dd/LL/y"),
          weight: undefined,
          waist: undefined,
          feedback_deals: undefined,
          feedback_education: undefined,
          feedback_goals: undefined,
          id: undefined,
          cloned: true
        });
        if (login?.settings?.nutri_advice?.start_cloned) {
          setNewAdvice({
            user_id: (user?.id || undefined),
            ...((objects || [])[0] || {}),
            attachments: [],
            idx: ((((objects || []).filter(fff => fff.epi === (user?.consent_status?.episode || 1)) || [])[0] || {}).idx || 0) + 1,
            identification: `${user?.consent_status?.episode || 1}:${((((objects || []).filter(fff => fff.epi === (user?.consent_status?.episode || 1)) || [])[0] || {}).idx || 0) + 1}`,
            episode: user?.consent_status?.episode || 1,
            epi: user?.consent_status?.episode || 1,
            advice_date: DateTime.now().toFormat("dd/LL/y"),
            weight: undefined,
            waist: undefined,
            feedback_deals: undefined,
            feedback_education: undefined,
            feedback_goals: undefined,
            id: undefined,
            cloned: true
          });
        } else {
          setNewAdvice({
            attachments: [],
            idx: ((((objects || []).filter(fff => fff.epi === (user?.consent_status?.episode || 1)) || [])[0] || {}).idx || 0) + 1,
            episode: user?.consent_status?.episode || 1,
            epi: user?.consent_status?.episode || 1,
            identification: `${user?.consent_status?.episode || 1}:${((((objects || []).filter(fff => fff.epi === (user?.consent_status?.episode || 1)) || [])[0] || {}).idx || 0) + 1}`,
            advice_date: DateTime.now().toFormat("dd/LL/y"),
            user_id: (user?.id || undefined)
          });
        }
        setEditOpen(true);
      }}
    />

    <CoachEditAdvice
      open={editOpen}
      user={user}
      setOpen={setEditOpen}
      advice={newAdvice}
      clonedAdvice={clonedAdvice}
      setAdvice={setNewAdvice}
      loading={mutationSave.isPending}
      objects={objects || []}
      onClick={(keepOpen: boolean) => {
        let formData = new FormData();
        formData.append('object', 'advice');
        formData.append('handler_id', (login?.id || "").toString());
        formData.append('fields[]', 'id');
        if (!!newAdvice.id) formData.append('ob[id]', newAdvice.id.toString());
        if (!!newAdvice.id) formData.append('id', newAdvice.id.toString());
        // mainObject
        formData.append('ob[user_id]', (user?.id || "").toString());
        formData.append('ob[practice_id]', (currentPractice?.id || "").toString());
        formData.append('ob[comment]', newAdvice?.comment || '');
        formData.append('ob[deals]', newAdvice?.deals || '');
        formData.append('ob[goals]', newAdvice?.goals || '');
        formData.append('ob[education]', newAdvice?.education || '');
        formData.append('ob[next_time]', newAdvice?.next_time || '');
        formData.append('ob[internal_comment]', newAdvice?.internal_comment || '');
        formData.append('ob[advice_date]', newAdvice?.advice_date || '');
        formData.append('ob[weight]', newAdvice?.weight || '');
        formData.append('ob[waist]', newAdvice?.waist || '');
        formData.append('ob[anamnese][breakfast]', newAdvice?.anamnese?.breakfast || '');
        formData.append('ob[anamnese][lunch]', newAdvice?.anamnese?.lunch || '');
        formData.append('ob[anamnese][diner]', newAdvice?.anamnese?.diner || '');
        formData.append('ob[anamnese][snack_1]', newAdvice?.anamnese?.snack_1 || '');
        formData.append('ob[anamnese][snack_2]', newAdvice?.anamnese?.snack_2 || '');
        formData.append('ob[anamnese][snack_3]', newAdvice?.anamnese?.snack_3 || '');
        formData.append('ob[anamnese][aversion]', newAdvice?.anamnese?.aversion || '');
        formData.append('ob[anamnese][preference]', newAdvice?.anamnese?.preference || '');
        formData.append('ob[anamnese][saturday]', newAdvice?.anamnese?.saturday || '');
        formData.append('ob[anamnese][sunday]', newAdvice?.anamnese?.sunday || '');
        formData.append('ob[anamnese][weekend_general]', newAdvice?.anamnese?.weekend_general || '');
        formData.append('ob[anamnese][pattern]', newAdvice?.anamnese?.pattern || '');
        formData.append('ob[anamnese][fluids]', newAdvice?.anamnese?.fluids || '');
        formData.append('ob[anamnese][extra_information]', newAdvice?.anamnese?.extra_information || '');
        formData.append('ob[anamnese][daily_dairy]', newAdvice?.anamnese?.daily_dairy || '');
        formData.append('ob[anamnese][daily_fats]', newAdvice?.anamnese?.daily_fats || '');
        formData.append('ob[anamnese][daily_fruits]', newAdvice?.anamnese?.daily_fruits || '');
        formData.append('ob[anamnese][daily_grains]', newAdvice?.anamnese?.daily_grains || '');
        formData.append('ob[anamnese][daily_meats]', newAdvice?.anamnese?.daily_meats || '');
        formData.append('ob[anamnese][daily_proteins]', newAdvice?.anamnese?.daily_proteins || '');
        formData.append('ob[anamnese][daily_salts]', newAdvice?.anamnese?.daily_salts || '');
        formData.append('ob[anamnese][daily_supplements]', newAdvice?.anamnese?.daily_supplements || '');
        formData.append('ob[anamnese][daily_veggies]', newAdvice?.anamnese?.daily_veggies || '');
        formData.append('ob[idx]', newAdvice?.idx?.toString() || '');
        formData.append('ob[episode]', newAdvice?.epi?.toString() || '');
        formData.append('ob[general_advice]', newAdvice?.general_advice || '');

        if (newAdvice.items) {
          newAdvice.items.forEach(item => {
            formData.append(`ob[items][]`, item);
          });
        }
        if (newAdvice.items_private) {
          newAdvice.items_private.forEach(item => {
            formData.append(`ob[items_private][]`, item);
          });
        }
        if (!newAdvice.attachments || newAdvice.attachments.length < 1) {
          formData.append(`ob[attachments][][id]`, '0');
        }
        if (newAdvice.attachments) {
          newAdvice.attachments.forEach(item => {
            formData.append(`ob[attachments][][id]`, item.id?.toString() || '');
          });
        }

        mutationSave.mutate({formData: formData, keepOpen: keepOpen});
      }}
    />

    <SnackDestroyed open={destroyedOpen} setOpen={setDestroyedOpen} />
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />

    {!!activeAdvice && <AiCoachAdviceReport
      advice={activeAdvice}
      open={aiReportOpen}
      setOpen={setAiReportOpen}
      title={t("coach.ai.advice_report.title")}
      onClose={() => {setActiveAdvice(undefined);}}
    />}

    <Base
      name="readContent"
      hidden={!showContent}
      maxWidth="xl"
      content={<Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography html>{showContent}</Typography>
        </Grid>
      </Grid>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn autoFocus onClick={() => {setShowContent(undefined);}}>{t("coach.general.actions.ok")}</Btn>
      </DialogActions>}
      open={!!showContent}
      setOpen={() => {setShowContent(undefined);}}
    />

    <Menu
      id="basic-menu"
      anchorEl={anch}
      open={menuOpen}
      onClose={() => {
        setAnch(null);
        setMenuAdvice(undefined);
        setMenuOpen(false);
      }}
    >
      <MenuItem onClick={() => {
        if (!!menuAdvice) setNewAdvice({
          ...menuAdvice,
          advice_date: DateTime.fromFormat(menuAdvice.advice_date, "y-LL-dd").toFormat("dd/LL/y")
        });

        setAnch(null);
        setMenuAdvice(undefined);
        setMenuOpen(false);
        setEditOpen(true);
      }}>
        <ListItemIcon>
          <EditIcon color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t("general.actions.edit")}</ListItemText>
      </MenuItem>
      {canTest && <MenuItem onClick={() => {
        setActiveAdvice(menuAdvice);
        setAiReportOpen(true);

        setAnch(null);
        setMenuAdvice(undefined);
        setMenuOpen(false);
      }}>
        <ListItemIcon>
          <AutoAwesomeIcon color="warning" fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t("advices.actions.generate_ai_report")}</ListItemText>
      </MenuItem>}
      <MenuItem onClick={() => {
        if (!!menuAdvice) mutationDestroy.mutate({
          formData: {
            object: 'advice',
            id: menuAdvice.id,
            ob: {
              id: menuAdvice.id,
            }
          }
        });

        setAnch(null);
        setMenuAdvice(undefined);
        setMenuOpen(false);
      }}>
        <ListItemIcon>
          <DeleteIcon color="secondary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t("general.actions.delete")}</ListItemText>
      </MenuItem>
    </Menu>
  </>;
}

